import { Link, useNavigate } from "react-router-dom";
import { encodeUrlParam } from "../../utils/urlUtils";

const StaffTabBar = ({ activeTab, useTab, UserName, onBeforeTabChange }) => {
  const navigate = useNavigate();
  // Encode email (including dots) to avoid IIS treating .com as executable file extension (403 on refresh)
  const encodedUserName = encodeUrlParam(UserName);
  const tabs = [
    { id: "updateInfo", label: "Update Info", link: `/staff/updateStaff/${encodedUserName}` },
    { id: "updatePassword", label: "Update Password", link: `/staff/updatePassword/${encodedUserName}` },
    { id: "rosterSchedule", label: "Schedule", link: `/staff/manageScheduleRoster/${encodedUserName}` },
    { id: "workReport", label: "Shift Report", link: `/staff/StaffShiftReport/${encodedUserName}` },
    { id: "payout", label: "Payouts", link: `/staff/payout/${encodedUserName}` },
  ];

  return (
    <ul className="nav nav-tabs nav-tabs-v2 px-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            className={`nav-link px-2 ${activeTab === tab.id ? "active" : ""}`}
            {...(useTab === true ? { "data-bs-toggle": "tab" } : {})}
            onClick={async (e) => {
              if (tab.id === activeTab) {
                e.preventDefault();
                return;
              }

              if (typeof onBeforeTabChange === "function") {
                e.preventDefault();
                const canNavigate = await onBeforeTabChange(tab.id, tab.link);
                if (canNavigate !== false) {
                  navigate(tab.link);
                }
              }
            }}
          >
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default StaffTabBar;